
export class CumulativeInvoice {

    name: string;
    y: string;
    color: string;
    visible: boolean;
    billingType: string;

    constructor() {
        this.name = "";
        this.y = "";
        this.color = "";
        this.visible = true;
        this.billingType = "";
    }

}

